import { render, staticRenderFns } from "./Borrowers.vue?vue&type=template&id=67893a82&scoped=true&"
import script from "./Borrowers.vue?vue&type=script&lang=js&"
export * from "./Borrowers.vue?vue&type=script&lang=js&"
import style0 from "./Borrowers.vue?vue&type=style&index=0&id=67893a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67893a82",
  null
  
)

export default component.exports